import {inject, Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {ToastType} from './toast-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly messageService: MessageService = inject(MessageService);

  public fireToast(type: ToastType, label: string, content: string, life: number = 3000): void {
    this.messageService.add(
      {
        severity: type,
        summary: label,
        detail: content,
        life: life
      });
  }
}
